import { IDeleteControledePatrimonioInspecaoUseCase } from "../../../presentation/useCases/delete/delete_controlede_patrimonio_inspecao_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DeleteControledePatrimonioInspecaoUseCase
 */

export class DeleteControledePatrimonioInspecaoUseCase implements IDeleteControledePatrimonioInspecaoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deleteControledePatrimonioInspecao(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
  ): Promise<void> {
    await this.repository.deleteControledePatrimonioInspecao(
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
    );
  }
}
